const initialState = {
  riders: [],
};

export const rider_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_RIDERS":
      return {
        ...state,
        riders: action.payload,
      };
    case "DELETE_RIDER":
      return {
        ...state,
        riders: state.riders.filter((li) => li.id !== action.payload),
      };
    default:
      return state;
  }
};
